import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHourglass = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.75 2C4.33579 2 4 2.33579 4 2.75C4 3.16421 4.33579 3.5 4.75 3.5H5.5V6.48166C5.5 8.1122 6.33634 9.62878 7.71533 10.4989L9.75939 11.7886C9.91485 11.8867 9.91485 12.1133 9.75939 12.2114L7.71533 13.5011C6.33634 14.3712 5.5 15.8878 5.5 17.5183V20.5H4.75C4.33579 20.5 4 20.8358 4 21.25C4 21.6642 4.33579 22 4.75 22H19.25C19.6642 22 20 21.6642 20 21.25C20 20.8358 19.6642 20.5 19.25 20.5H18.5V17.5183C18.5 15.8878 17.6637 14.3712 16.2847 13.5011L14.2406 12.2114C14.0851 12.1133 14.0851 11.8867 14.2406 11.7886L16.2847 10.4989C17.6637 9.62878 18.5 8.1122 18.5 6.48166V3.5H19.25C19.6642 3.5 20 3.16421 20 2.75C20 2.33579 19.6642 2 19.25 2H4.75ZM17 3.5H7V6.48166C7 7.59729 7.57223 8.63495 8.51575 9.23027L10.5598 10.52C11.648 11.2066 11.648 12.7934 10.5598 13.48L8.51575 14.7697C7.57223 15.365 7 16.4027 7 17.5183V20.5H17V17.5183C17 16.4027 16.4278 15.365 15.4842 14.7697L13.4402 13.48C12.352 12.7934 12.352 11.2066 13.4402 10.52L15.4842 9.23027C16.4278 8.63495 17 7.59729 17 6.48166V3.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgHourglass;
